
import { WordPair } from "@/types/game";
import { debugLog, DebugLevel, captureStateSnapshot } from "@/utils/debugUtils";

/**
 * Captures the current state of the game for debugging
 */
export const captureRoundPreparationState = (
  stage: string,
  gameId: string,
  roundNumber: number,
  userWord: string | null,
  aiWord: string | null,
  userHasSubmitted: boolean,
  botHasChosenWord: boolean,
  botIsThinking: boolean
): void => {
  captureStateSnapshot(
    `roundPreparation:${stage}`, 
    stage === "start" ? "prepareNextRound" : 
      stage === "beforeAI" ? "startingAIGeneration" : "aiGenerationComplete", 
    gameId, 
    roundNumber,
    userWord,
    aiWord,
    userHasSubmitted,
    botHasChosenWord,
    botIsThinking
  );
};

/**
 * Updates the rounds state with proximity data without adding new rounds
 */
export const updateRoundsWithProximity = (
  setRounds: (rounds: WordPair[] | ((prev: WordPair[]) => WordPair[])) => void,
  currentRoundNumber: number
): void => {
  setRounds(prevRounds => {
    // Make sure not to add a new round, just update proximityScore of existing round
    return prevRounds.map((round, index) => {
      if (index === currentRoundNumber - 1) {
        // Update the proximity score for the current (just completed) round
        return {
          ...round,
          proximityScore: round.proximityScore // Keep existing proximity score
        };
      }
      return round;
    });
  });
  
  debugLog(DebugLevel.INFO, "roundPreparation", "Updated rounds with proximity data without adding new rounds");
};
